<template>
  <div>
    <CardWrapper :has-access="1" :is-loading="preloader">
      <template #title>ТАБЛО ВЫЛЕТА</template>
      <template #icon><DepartureIcon/></template>
      <TableWrapper>
        <v-data-table
          :headers="this.headers"
          :items="this.departureBoard"
          :search="search"
          class="elevation-0 small-table maxH"
          rows-per-page-text="Строк на странице"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>
              <span class="body-2">{{ props.item.FlightNumber }}</span>
            </td>
            <td class="text-xs-left ws-no">
              <v-icon>flight_takeoff</v-icon>
              {{ props.item.DepTime }}
            </td>
            <td class="text-xs-left">{{ props.item.ap_name }}</td>
            <td class="text-xs-left">
              <div v-if="props.item.logo" v-html="imgWrap(props.item.logo, logoSize)"></div>
            </td>
            <td class="text-xs-left">{{ props.item.CheckIn }}</td>
            <td class="text-xs-left">{{ props.item.Exit }}</td>
            <td class="text-xs-left">
              <v-chip
                :color="props.item.StatusColor || 'blue-grey lighten-3'"
                small
                text-color="white"
              >{{ (props.item.Status || 'по расписанию').toLowerCase() }}</v-chip>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          >Поиск по "{{ search }}" не дал результатов.</v-alert>
        </v-data-table>

      </TableWrapper>
    </CardWrapper>
  </div>
</template>

<script>
import store from '@/store'
import CardWrapper from "../ui/CardWrapper.vue";
import DepartureIcon from "../ui/icons/DepartureIcon.vue";
import TableWrapper from "../ui/TableWrapper.vue";

let headers = [
  {
    text: '№ Рейса',
    align: 'left',
    sortable: false,
    value: 'FlightNumber',
  },
  {
    text: 'Отправление',
    sortable: false,
    value: 'DepTime',
  },
  {
    text: 'Направление',
    sortable: false,
    value: 'NameAirport',
  },
  {
    text: 'Авиакомпания',
    sortable: false,
    value: 'Airline',
  },
  {
    text: 'Стойки',
    sortable: false,
    value: 'CheckIn',
  },
  {
    text: 'Посадка',
    sortable: false,
    value: 'Exit',
  },
  {
    text: 'Статус',
    sortable: false,
    value: 'Status',
  },
]

export default {
  components: {TableWrapper, DepartureIcon, CardWrapper},
  data() {
    return {
      search: '',
      headers: headers,
      logoSize: 20,
    }
  },
  computed: {
    departureBoard: {
      get() {
        return store.getters['board/getDepartureBoard']('current')
      },
    },
    preloader: {
      get() {
        return store.getters['board/getDeparturePreloader']
      },
      set(value) {
        store.commit('board/setDeparturePreloaderState', value)
      },
    },
  },
  methods: {
    update: function() {
      store.dispatch('board/updateDepartureBoard')
    },
    imgWrap: function(url, size) {
      return '<img height="' + size + 'px" src="' + url + '"/>'
    },
  },
}
</script>

